import React from "react"
import PropTypes from "prop-types"
import "./UtilizationDetailView.scss"
import Footer from "../../components/Footer"
import UtilizationUnitDetailTableControlledWithData from "../../components/UtilizationUnitDetailTable/UtilizationUnitDetailTableControlledWithData"

const UtilizationDetailView = props => {
  return (
    <div className="UtilizationDetailView">
      <UtilizationUnitDetailTableControlledWithData />
      <Footer />
    </div>
  )
}

UtilizationDetailView.propTypes = {
  match: PropTypes.shape({
    params: PropTypes.shape({
      facilityId: PropTypes.string,
      deviceTypeId: PropTypes.string,
    }),
  }),
}

export default UtilizationDetailView
